import {
    save_data_Success,
    save_data_prepare,
    change_representativeCmpx_Success,
    set_stimulator_Success
} from "../../actions/actionConstants";

const updateEditState = (state, action) => {
    if (state === undefined) {
        return {
            data: null,
            needSave: false
        };
    }

    switch (action.type) {
        case save_data_prepare: {
            const { diff } = action.payload;
            const data = {
                needSave: true,
                data: {
                    ...state.app.editState.data,
                    ...diff
                }
            };

            // Ключи для удаления
            let keysForDelete = state.app.editState.data?.forDeleting ?? [];

            // Не удалять заново установленные параметры
            keysForDelete = keysForDelete.filter(_key => !Object.prototype.hasOwnProperty.call(diff, _key));

            // Оставить уникальные значения
            keysForDelete = [...new Set([...keysForDelete, ...Object.keys(diff).filter(key => diff[key] === null)])];
            data.data.forDeleting = keysForDelete;
            return data;
        }

        case change_representativeCmpx_Success:
        case set_stimulator_Success:
        case save_data_Success: // NEED RESET DATA
            return {
                needSave: false,
                data: null
            };
        default:
            return state.app.editState;
    }
};
export default updateEditState;
